import { ApplianceType } from '@alpinehomeair/common';
import {
  autoUpdate,
  flip,
  FloatingPortal,
  offset,
  shift,
  useFloating
} from '@floating-ui/react';
import SpaceInfoCard from 'components/structure-page/2d/space-info-card';
import { BTUsType } from 'data/types';

type SpaceInfoHoverCardProps = Readonly<{
  open: boolean;
  label: string;
  widthFt: number;
  heightFt: number;
  BTUs?: BTUsType;
  showBTUs?: boolean;
  hasSectionColor?: boolean;
  sectionTextColor?: string;
  applianceCount?: number;
  showApplianceCount?: boolean;
  appliances?: ApplianceType[];
  onRemoveAppliance?: (applianceUniqueId: string) => void;
  squareFootage?: number | null;
  showDimensions?: boolean;
}>;

export default function SpaceInfoHoverCard({
  open,
  label,
  widthFt,
  heightFt,
  BTUs,
  showBTUs = false,
  hasSectionColor = false,
  sectionTextColor,
  applianceCount = 0,
  showApplianceCount = false,
  appliances = [],
  onRemoveAppliance,
  squareFootage,
  showDimensions = true
}: SpaceInfoHoverCardProps) {
  const { refs, floatingStyles } = useFloating({
    open,
    placement: 'top',
    whileElementsMounted: autoUpdate,
    middleware: [offset(5), flip(), shift({ padding: 5 })]
  });

  return (
    <>
      <div
        ref={refs.setReference}
        className='pointer-events-none absolute inset-0'
      />
      {open && (
        <FloatingPortal>
          <div
            ref={refs.setFloating}
            style={floatingStyles}
            className='pointer-events-none z-50 rounded-lg bg-white p-3 shadow-lg ring-1 ring-black/5'
          >
            <SpaceInfoCard
              label={label}
              widthFt={widthFt}
              heightFt={heightFt}
              BTUs={BTUs}
              showBTUs={showBTUs}
              hasSectionColor={hasSectionColor}
              sectionTextColor={sectionTextColor}
              applianceCount={applianceCount}
              showApplianceCount={showApplianceCount}
              appliances={appliances}
              onRemoveAppliance={onRemoveAppliance}
              squareFootage={squareFootage}
              showDimensions={showDimensions}
            />
          </div>
        </FloatingPortal>
      )}
    </>
  );
}
